import { render, staticRenderFns } from "./wallpaper.vue?vue&type=template&id=d7097bc6"
import script from "./wallpaper.vue?vue&type=script&lang=js"
export * from "./wallpaper.vue?vue&type=script&lang=js"
import style0 from "./wallpaper.vue?vue&type=style&index=0&id=d7097bc6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports